// @flow
import * as React from 'react';
import { SvgUri } from 'react-native-svg';
import { Image, Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    tinyLogo: {
        width: 120,
        height: 120,
    },
});

type Props = {
    imageUrl: String
};

const ProfileIcon = (props: Props) => {
    const { imageUrl } = props;
    return (
        Platform.OS === 'web'
            ? (
                <Image
                    source={{
                        uri: imageUrl,
                    }}
                    style={styles.tinyLogo}
                />
            )
            : (
                <SvgUri
                    width="100%"
                    height="100%"
                    uri={imageUrl}
                />
            )
    );
};

export default ProfileIcon;
